import qs from 'qs'
export default {
    /**
     * 深度克隆对象，不支持对象内方法的克隆
     * @param {Objectany} source 待拷贝对象
     * @returns {Object}
     */
    deepClone(source) {
        return JSON.parse(JSON.stringify(source))
    },
    /**
     * @method HTMLDecode 反转义特殊字符
     * @param {String} text 字符串
     * @returns {String}
     */
    HTMLDecode(text) {
        let temp = document.createElement("div")
        temp.innerHTML = text
        let output = temp.innerText || temp.textContent
        temp = null
        return output
    },
     /**
     * @method decodeObj() 转化html中的转义字符
     * @param obj 获取的对象
     * @returns {Object}
     */
    decodeObj(obj) {
        if (typeof obj === 'string') {
            return this.HTMLDecode(obj)
        } else if (typeof obj === 'object' && !(obj instanceof Array) && obj !== null) {
            //object
            let temp = {}
            for (let [key, value] of Object.entries(obj)) {
                temp[key] = this.decodeObj(value)
            }
            return temp
        } else if (typeof obj === 'object' && obj instanceof Array) {
            // array
            return obj.map(item => {
                return this.decodeObj(item)
            })
        }
        return obj
    },
        /**
     * @method SetRefreshToken  accessToken过期之后用refreshToken重新获取新token
     * @param that vue实例
     ***/
    async SetRefreshToken(that) {
        let refreshToken = localStorage.getItem('refreshToken')
        let clientId = localStorage.getItem('checked') ? 'web_client_remember' : 'web_client'
        let isKeepLive = true
        let value = {
            'refresh_token': refreshToken,
            'grant_type': 'refresh_token',
            'client_id': clientId,
            "client_secret": 'web_client'
        }
        await axios({
            url: '/evo-apigw/evo-oauth/oauth/token',
            method: 'post',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(value)
        }).then((res) => {
            if (res.data.code === '0') {
                localStorage.setItem("accessToken", res.data.data.access_token)
                localStorage.setItem("refreshToken", res.data.data.refresh_token)
                localStorage.setItem('expiresTime', new Date().getTime() + res.data.data.expires_in * 1000)
                isKeepLive = true
            } else {
                // 客户端没有refreshtoken
                if (localStorage.clientType === '2') {
                    return
                }
                isKeepLive = false
                if (that.$route.path === '/login') {
                    return false
                }
                // 不清除记住密码和rememberToken的缓存
                this.localSClear(['UserName', 'language', 'checked', 'rememberToken'])
                parent.location.hash = "#/login"
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    window.location.reload()
                }
                return false
            }
        }).catch((error) => {
            parent.location.hash = "#/login"
        })
        return isKeepLive
    },
    /**
     * @description: 过滤表单中key不存在的字段
     * @param {object} values 表单值 filterValue
     * @param {boolean} filterValue 是否过滤表单中value为 undefined | null 的字段
     * @return: 返回过滤后的表单值
     */
    formFilter(values, filterValue = true) {
        if(Object.prototype.toString.call(values) !== '[object Object]') {
            return {}
        }
        Object.keys(values).map(item => {
            if(!item) {
                delete values[item]
                return
            }
            if(filterValue && (values[item] === undefined || values[item] === null) ) {
                delete values[item]
            }
        })
        return values
    },
    /**
     * @description: 表单回显填充数据
     * @param {object} formData 表单原始对象
     * @param {object} newData 要填充的数据对象
     */
    formSetData(formData, newData) {
        Object.keys(formData).map(item => {
            if(newData[item] != undefined) {
                formData[item] = newData[item]
            }
        })
    },
       /**
     * @method getDataType() 判定数据类型
     * @param {any} object 传入的数据类型
     * @returns {string} 数据类型，均为小写
     */
    getDataType(object) {
        // IE9下调用toString.call(undefined)报错
        if (typeof object === 'undefined') {
            return 'undefined'
        }
        let map = {
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Boolean]': 'boolean',
            '[object Object]': 'object',
            '[object Array]': 'array',
            '[object RegExp]': 'regExp',
            '[object Function]': 'function',
            '[object Promise]': 'promise',
            '[object GeneratorFunction]': 'generatorFunction',
            '[object Null]': 'null',
        }
        let typeString = ''
        if (object instanceof Element) {
            typeString = 'element'
        } else {
            typeString = map[Object.prototype.toString.call(object)]
        }
        return typeString
    },
    //深拷贝
    deepCopy(obj) {
        // Hash表 记录所有的对象引用关系
        let map = new WeakMap();
        function dp(obj) {
            let result = null;
            let keys = null,
                key = null,
                temp = null,
                existObj = null;

            existObj = map.get(obj);
            // 如果这个对象已被记录则直接返回
            if (existObj) {
                return existObj;
            }
            keys = Object.keys(obj);
            result = {};
            // 记录当前对象
            map.set(obj,result);
            for (let i = 0; i < keys.length; i++) {
                key = keys[i];
                temp = obj[key];
                // 如果字段的值也是一个对象则递归复制
                if (temp && (Object.prototype.toString.call(temp) === '[object Array]' || Object.prototype.toString.call(temp) === '[object Object]')) {
                    result[key] = dp(temp);
                } else {
                    // 否则直接赋值给新对象
                    result[key] = temp;
                }
            }
            return result;
        }
        return dp(obj);
    },
    //防抖, 一段时间内只执行最后一次请求
    debounce(fn, delay = 1000) {
        let that = this;
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            fn.apply(that);
        }, delay)
    },
    GetRequest() {
        var url = window.location.href; //获取url中"?"符后的字串
        // var url = str
        var theRequest = new Object();
        if (url.indexOf('?') != -1) {
            url = url.substr(1);
        }
    
        if (url) {
            let temp = url.split('?')
            let b = temp[1].split('#')
            var strs = b[0].split('&')
            
            for (var i = 0; i < strs.length; i++) {
                var srtArry = strs[i].split('=');
                var y = srtArry.shift();
                theRequest[y] = srtArry.join('=');
            }
        }
        return theRequest;
    },
    
    getImgUrl(url, id) {
        if (!url) return ''
        if (!id) return ''
        const visitorVersion = localStorage.getItem('evo-visitor')
        return (
            location.origin + `/evo-apigw/evo-visitor/${visitorVersion || '1.0.0'}/h5/config/web-h5/skipOss?visitorId=` + id + '&test=test.jpg'
        );
    }
    
}
